import { query as servicesQuery } from './services-api';

export { autoGenerateKey } from './ts-rest';
export type { ResponseBody } from './ts-rest';
export { api as servicesApi, query as servicesQuery } from './services-api';
export type { Contract as ServicesContract } from './services-api';

export function ApiProvider({ children }: { children: React.ReactNode }) {
  return <servicesQuery.ReactQueryProvider>{children}</servicesQuery.ReactQueryProvider>;
}
